import { _USER } from "@/state";
import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';

export default (to, from, next) => {
    if (!!_USER().isAuthenticated()) {
        let route = to.matched.find(r => r.name == to.name)
        route.meta.gate ??= []
        if (route.meta.gate.length && !_USER().isAbleToAny(route.meta.gate)) {
            return next(getRoute('error', { type: 404 }));
        }
        return next();
    } else {
        return next(getRoute('login'))
    }
}